const objFunc = () => {
  return {
    all: []
  }
}

export default objFunc()

export const defaultObj = objFunc()
